import { Col, Typography, Layout, Space } from "antd";
import Header160 from '../../../header/header';
const { Title, Text } = Typography;
export default function DashboardHeader({ onRefresh }) {
  return (
    <div className="container" style={{ paddingBottom: 20}}>
      <Layout className="container">
        <div className="header-filter-container d-flex align-items-center justify-content-between">
          <Header160 />
          <Col flex="auto" style={{ textAlign: "center" }}>
            <Space direction="vertical" size={0}>
              <Title
                level={3}
                style={{
                  margin: 0,
                  color: "#042956",
                  fontWeight: 600
                }}
              >
                Dashboard Financiero
              </Title>

              <Text
                style={{
                  color: "#6b7280",
                  fontSize: 14
                }}
              >
                Control de inventario, entregas y movimientos
              </Text>
            </Space>
          </Col>
        </div>
      </Layout>
    </div>
  );
}